lookSection={
    scrollPosition: 0
}
$('.shop-the-look-list-js').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow"></button>',
});

$('.js-look-list-triger').on('click',function (){
   const tabId= $(this).attr('data-product-tab-id');
   $(this).closest('.look-list-item').find('.look-products-list-item').removeClass('active');
   $(this).closest('.look-list-item').find(`.look-products-list-item[data-product-tab="${tabId}"]`).addClass('active');
   $(this).closest('.look-list-item').find('.js-look-list-triger').removeClass('active');
   $(this).closest('.look-list-item').find(`.js-look-list-triger[data-product-tab-id="${tabId}"]`).addClass('active');
    if (window.matchMedia("(max-width: 767px)").matches) {
        const blockIndex= $(this).attr('data-block-index');
        $(this).closest('.shop-the-look').find('.loock-list-product-popup').find('.look-products-list-item').removeClass('active');
        $(this).closest('.shop-the-look').find($(`.look-products-list-${blockIndex}`)).find(`.look-products-list-item[data-product-tab="${tabId}"]`).addClass('active');
        lookSection={
            scrollPosition: window.scrollY
        }
    }
});
$('.js-close-look-tab').on('click',function (){
    $(this).closest('.product-item').removeClass('active');

});
$(window).scroll(function (){
    if(window.scrollY - lookSection.scrollPosition > 150 || window.scrollY - lookSection.scrollPosition < -150){
        $('.loock-list-product-popup').find('.product-item').removeClass('active');
    }
});

function ProductsSwatch(item){
    let productGrid =item.closest('.product-grid-item__inner')
    let productSwatch =$(productGrid).find('.product-grid-item__swatch')
     let productSwatchCollections =$(productGrid).closest('.collection__inner').find(productGrid).find('.product-grid-item__swatch');
    let productSwatchSetCreator =$(productGrid).closest('.set-creator-product-grid').find(productGrid).find('.product-grid-item__swatch');
    if(productSwatchCollections.length > 0){
      /*Azem*/
        if(productSwatchCollections.children().length > 7) {
            productSwatchCollections.slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerPadding: '16px',
                prevArrow: '<button class="slick-prev slick-arrow"></button>',
                nextArrow: '<button class="slick-next slick-arrow"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            centerMode: false,
                            centerPadding: '10px',
                        }
                    }
                ]
            });
        }else{
            productSwatchCollections.addClass('small-slider')
            if(productSwatchCollections.children().length <= 3){
                productSwatchCollections.addClass('small-slider-mobile-small')
            }else if(productSwatchCollections.children().length <= 4){
                productSwatchCollections.addClass('small-slider-mobile')
            }else if(productSwatchCollections.children().length <= 5){
                productSwatchCollections.addClass('small-slider-tablet')
            }
            productSwatchCollections.slick({
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: false,
                centerPadding: '16px',
                prevArrow: '<button class="slick-prev slick-arrow"></button>',
                nextArrow: '<button class="slick-next slick-arrow"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            centerMode: true,
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            centerMode: true,
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            centerMode: false,
                            centerPadding: '10px',
                        }
                    }
                ]
            });
        }
    }else if(productSwatchSetCreator.length > 0){
        if(productSwatchSetCreator.children().length > 7) {
            productSwatchSetCreator.slick({
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: '16px',
                prevArrow: '<button class="slick-prev slick-arrow"></button>',
                nextArrow: '<button class="slick-next slick-arrow"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '10px',
                        }
                    }
                ]
            });
        }else{
            productSwatchSetCreator.addClass('small-slider')
            if(productSwatchSetCreator.children().length <= 3){
                productSwatchSetCreator.addClass('small-slider-mobile-small')
            }else if(productSwatchSetCreator.children().length <= 4){
                productSwatchSetCreator.addClass('small-slider-mobile')
            }else if(productSwatchSetCreator.children().length <= 5){
                productSwatchSetCreator.addClass('small-slider-tablet')
            }
            productSwatchSetCreator.slick({
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: false,
                centerPadding: '16px',
                prevArrow: '<button class="slick-prev slick-arrow"></button>',
                nextArrow: '<button class="slick-next slick-arrow"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            centerMode: true,
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            centerMode: true,
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '10px',
                        }
                    }
                ]
            });
        }
    }else if(productSwatch.length > 0) {
        if (productSwatch.children().length > 7) {
            productSwatch.slick({
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: '16px',
                prevArrow: '<button class="slick-prev slick-arrow"></button>',
                nextArrow: '<button class="slick-next slick-arrow"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '10px',
                        }
                    }
                ]
            });
        } else {
            productSwatch.addClass('small-slider')
            if(productSwatch.children().length <= 3){
                productSwatch.addClass('small-slider-mobile-small')
            }else if(productSwatch.children().length <= 4){
                productSwatch.addClass('small-slider-mobile')
            }else if(productSwatch.children().length <= 5){
                productSwatch.addClass('small-slider-tablet')
            }
            productSwatch.slick({
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: false,
                centerPadding: '16px',
                prevArrow: '<button class="slick-prev slick-arrow"></button>',
                nextArrow: '<button class="slick-next slick-arrow"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            centerMode: true,
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            centerMode: true,
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            centerMode: true,
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '10px',
                        }
                    }
                ]
            });
            productSwatch.addClass('small-slider')
        }
    }
}
$(document).on('click', '.js-grid-swatch .swatch__button', function (){
    $(this).closest('.product-grid-item').find('.swatch__button').removeClass('active');
    $(this).addClass('active');
    const variantJson = JSON.parse($(this).closest('.product-grid-item').find('[type="application/json"]')[0].textContent)
    const curentVariantId = parseInt($(this).find('.swatch__label').attr('data-swatch-variant')) ;
    const curentVariantJson = variantJson.find(variant=>variant.id == curentVariantId);
    const forminput = $(this).closest('.product-grid-item').find('.quick__add__form input[name="id"]');
    const formbutton = $(this).closest('.product-grid-item').find('.quick__add__form button[type="submit"]');
    const price = $(this).closest('.product-grid-item').find('.product-grid-item__price.price');
    forminput.val(curentVariantJson.id)
    formbutton.attr('data-product-id',curentVariantJson.id)
    if(curentVariantJson.available){
        formbutton.removeAttr('disabled')
    }else{
        formbutton.attr('disabled', 'disabled')
    }
    if(curentVariantJson.compare_at_price != null){
        price[0].innerHTML = `${Shopify.formatMoney(curentVariantJson.price,'')} <s>${Shopify.formatMoney(curentVariantJson.compare_at_price,'')}<s/>`
    }else{
        price[0].innerHTML = `${Shopify.formatMoney(curentVariantJson.price,'')}`
    }
    if(curentVariantJson.featured_image != null){
        const imageBlock = $(this).closest('.product-grid-item').find('.product__media.product__media--featured');
        imageBlock.attr('data-bgset',curentVariantJson.featured_image.src)
    }else{
        const imageBlock = $(this).closest('.product-grid-item').find('.product__media.product__media--featured');
        imageBlock.attr('data-bgset', imageBlock.attr('data-default-bgset'))
    }
})
$('.js-notification-popup-btn').on('click', function (){
    $(this).closest('.product__block').find('.product__notification-popup').addClass('open')
    $('body').addClass('quick-view-visible')
});
$('.product__notification-popup').on('click', function (e){
    const popup = $('.product__block').find('.product__notification-popup.open form')
    if (!popup[0].contains(e.target) && !popup[0].contains(e.target)) {
        popup.closest('.product__notification-popup').removeClass('open');
        $('body').removeClass('quick-view-visible')
    }
});
setHeaderHeight()
function setHeaderHeight(){
    const barHeight = $('.announcement-bar-redesign').height();
    const headerHeight = $('.site-header.redesign').height();
    const style = `<style>.body-redesign.has-transparent-header #shopify-section-header.header--sticky.header-redesign{top: ${barHeight}px!important}</style>`
    $('#nav-drawer').css("height",`calc(100svh - ${barHeight}px)`);
    $('.header-redesign').prepend(style);
}
$(window).resize(function (){
    setHeaderHeight();
})
$('.js-tabs-control .tabs-control-item').on('click',function (){
    if(!$(this).hasClass('active')){
        const tabId = $(this).attr('data-tab-id');
        $('.grid-tabs-item').addClass('hidden');
        $(`.grid-tabs-item[ data-tab="${tabId}"]`).removeClass('hidden');
        $('.tabs-control-item').removeClass('active');
        $(this).addClass('active');
    }
});
function selectTemplateResult(opt) {
    if (!opt.id) {
        return opt.text;
    }
    let swatch = $(opt.element).data("style");
    if(!swatch){
        let $opt = $(
            `<div class="select2-results__option-custom product-options-list-item">
               <span class="swatch" style="background-color: red"></span> <span class="label">${opt.text}</span>
        </div>`
        );
        return $opt;
    }else{
        let $opt = $(
            `<div class="select2-results__option-custom product-options-list-item">
               <span class="swatch" style="${swatch}"></span> <span class="label">${opt.text}</span>
        </div>`
        );
        return $opt;
    }
}
function selectTemplateSelection(opt) {
    let swatch = $(opt.element).data("style");
    if(!swatch){
        let result = `
				<div class="active-value">
                    <span class="swatch" style="background-color: red"></span> <span class="label">${opt.text}</span>
				</div>
			`;

        return $(result);
    }else{
        let result = `
				<div class="active-value">
                    <span class="swatch" style="${swatch}"></span> <span class="label">${opt.text}</span>
				</div>
			`;

        return $(result);
    }
}
initSelect()
$(window).resize(function (){
    initSelect();
})

function initSelect(){
    if($('body').hasClass('template-product-set')) {
        if (window.matchMedia("(min-width: 768px)").matches) {
            $('.js-option-dropdown-set').select2({
                minimumResultsForSearch: -1,
                templateResult: selectTemplateResult,
                templateSelection: selectTemplateSelection,
                placeholder: "Wähle die Farbe",
            });
        } else {
            $('.js-option-dropdown-set').select2({
                minimumResultsForSearch: -1,
                templateResult: selectTemplateResult,
                templateSelection: selectTemplateSelection,
                placeholder: "Wähle die Farbe",
                dropdownParent: $('.mobile-option-popup .mobile-option-popup-list'),
            });
        }
    }
}
$('.js-option-dropdown-set').on('select2:opening', function (e) {
    if (window.matchMedia("(max-width: 768px)").matches) {
        setTimeout(function () {
            $('.mobile-option-popup').addClass('open');
            $('body').addClass('custom-modal-open');
        }, 350)
    }
});
$('.js-option-dropdown-set').on('select2:close', function (e) {
    if (window.matchMedia("(max-width: 768px)").matches) {
        $('.mobile-option-popup').removeClass('open');
        $('body').removeClass('custom-modal-open');
    }
});
$('.js-set-products-list').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: true,
    prevArrow: '<div class="slick-prev slick-arrow"></div>',
    nextArrow: '<div class="slick-next slick-arrow"></div>',
    responsive: [
        {
            breakpoint: 1020,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
            }
        },
        {
            breakpoint: 475,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
            }
        },
    ]
});
$('.js-option-dropdown').on('click',function (){
    $('.js-option-dropdown').removeClass('open');
    $(this).addClass('open');
});
function getSwatchJson(){
    let jsonResult = {};
    $.ajax({
        url:theme.assets.swatches,
        dataType: 'json',
        async: false
    }).done(function(json) {
        jsonResult = json;
    }).fail(function(error) {
        console.log(error)
    });
    return jsonResult.colors;
}

let setProdutVariant = $('.js-set-product-options');
let SwatchJson = getSwatchJson();
setProdutVariant.each(function (index){
    const _this = $(this);
    const variantJson = JSON.parse($(this).find('[type="application/json"]').html());
    variantJson.forEach(function (item){
        const option = _this.find($(`option[data-title="${item.title}"]`));
        const colorOptions = SwatchJson.find(element => Object.keys(element).toString().toLowerCase()=== item.title.toLowerCase());
      if(colorOptions){
          const colorValue = Object.values(colorOptions).toString();
          const defaultPath = theme.assets.base || '/';
          if(colorValue.includes('#')){
              option.attr('data-style', `background-color: ${colorValue};`)
          }else{
              option.attr('data-style', `background-color: #cccccc;background-image: url(${defaultPath}${colorValue});`)
          }
      }
    })
    if(index == setProdutVariant.length-1){
        initSelect();
    }
});
let cart_variant =$('.js-cart-swatch')
cart_variant.each(function (index){
    const option = $(this).attr('data-title');
    const colorOptions = SwatchJson.find(element => Object.keys(element).toString().toLowerCase()=== option.toLowerCase());
    if(colorOptions != undefined) {
        const colorValue = Object.values(colorOptions).toString();
        const defaultPath = theme.assets.base || '/';
        if (colorValue.includes('#')) {
            $(this).attr('style', `background-color: ${colorValue};`)
        } else {
            $(this).attr('style', `background-image: url(${defaultPath}${colorValue});`)
        }
    }
});
function initCartSwatch(){
    let cart_variant =$('.js-cart-swatch')
    cart_variant.each(function (index){
        const option = $(this).attr('data-title');
        const colorOptions = SwatchJson.find(element => Object.keys(element).toString().toLowerCase()=== option.toLowerCase());
        if(colorOptions != undefined){
            const colorValue = Object.values(colorOptions).toString();
            const defaultPath = theme.assets.base || '/';
            if(colorValue.includes('#')){
                $(this).attr('style', `background-color: ${colorValue};`)
            }else{
                $(this).attr('style', `background-color: #cccccc;background-image: url(${defaultPath}${colorValue});`)
            }
        }
    });
}
$('.js-set-product-options select').on("change",function (){
    const selectedValue = parseInt($(this).find(":selected").val());
    const variantJson = JSON.parse($(this).closest('.js-set-product-options').find('[type="application/json"]').html());
    const selectedVariantJson = variantJson.find(variant => variant.id === selectedValue);
    let price = ``;
    if(selectedVariantJson.featured_image != null){
        $(this).closest('.set-products-list-item').find(".image-wrapper img").attr('src',selectedVariantJson.featured_image.src)
    }else{
        let defaultImage = $(this).closest('.set-products-list-item').find(".image-wrapper img").attr('data-default-image')
        $(this).closest('.set-products-list-item').find(".image-wrapper img").attr('src',defaultImage)
    }
    if(selectedVariantJson.compare_at_price != null){
        price = ` ${Shopify.formatMoney(selectedVariantJson.price)} <s>${Shopify.formatMoney(selectedVariantJson.compare_at_price)}</s>`
    }else{
        price = ` ${Shopify.formatMoney(selectedVariantJson.price)}`
    }
    $(this).closest('.set-products-list-item').find(".price").html(price);
});
$('.js-add-set').on('click',function (e){
    e.preventDefault();
    const setVariants = $('.js-set-product-options select');
    let addToCart = true;
    let cartVariants = [];
    setVariants.each(function (){
        const value = $(this).find(":selected").val();
        const product = $(this).find(":selected").attr('data-product');
        // const variant = $(this).find(":selected").attr('data-title');
        const variant = $(this).find(":selected").attr('data-variant');
        var properties = {
            // 'Liquid_Lipstick': 'Set'
        };
        const propertiy_name = $(this).find(":selected").attr('data-property-name');
        const propertiy_value = $(this).find(":selected").attr('data-property-value');
        properties[propertiy_name] = propertiy_value
        console.log(properties);
        if(value != ""){
            if(cartVariants.length > 0){
                var variantExsits = false;
                cartVariants.map(function (value,index){
                    if(value.id === variant){
                        cartVariants[index].quantity = cartVariants[index].quantity+1;
                        variantExsits = true;
                    }
                    if((index+1) == cartVariants.length){
                        if(!variantExsits){
                            cartVariants.push({
                                id: variant,
                                quantity: 1,
                                price: 10,
                                final_price: 10,
                                properties
                            });
                        }
                    }
                })
            }else{
                cartVariants.push({
                    id: variant,
                    quantity: 1,
                    price: 10,
                    final_price: 10,
                    properties
                });
            }
            let property = `<input type="hidden" class="js-set-properties" name="properties[${product}]" value="${variant}">`
            $(this).closest('form.product__form').prepend(property);
            $(this).closest('.js-set-product-options').find('.select2.select2-container').removeClass('error')
        }else {
            $(this).closest('.js-set-product-options').find('.select2.select2-container').addClass('error')
            addToCart = false;
        }
    })
    if(addToCart){
        
        let formData = {
            items: cartVariants
        };

        fetch('/cart/add.js',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                // Error function
                errorMessage(response)
                return;
            }
            setTimeout(function (){
                updateCartDrawer(true);
            },500)
        })
        .catch((error) => {
            console.log(error);
        });

        //  $('.js-set-submit-btn').click();
        //  $(this).addClass('is-loading');
        //  $(this).closest('form.product__form').find('[data-cart-errors-container]').removeClass('is-visible')
        // setTimeout(function (){
        //     updateCartDrawer(true);
        //     $('.js-set-properties').remove();
        //     _this.removeClass('is-loading');
        // },500)
    }else{
        $('.js-set-properties').remove();
        $(this).closest('form.product__form').find('[data-cart-errors-container]').html(`<div class="errors">${theme.strings.set_error}<button type="button" class="product__errors__close" data-close-error>${theme.icons.closeSmall}</button></div>`)
        $(this).closest('form.product__form').find('[data-cart-errors-container]').addClass('is-visible')
    }
})
$(document).on('click','.js-quantity-button',function (e){

})
$(document).on('change','.js-quantity-input',function (e){
    const event = new Event('countChange');
    $(this)[0].dispatchEvent(event);
});
$(document).on('click','.js-quantity-button',function (e){
    e.preventDefault();
    const button = $(this);
    const input = $(this).closest('.quantity').find('.quantity-input');
    const value = parseInt(input.val());
    let quantities = $('.quantity-input')
    if(button.hasClass('quantity-minus')){
        if(value > 0){
            input.val(value-1)
            input.trigger('change')
        }
    } else {
        input.val(value + 1)
        input.trigger('change')
    }

});
$('.js-add-address').on('click',function (){
   $('#AddAddress').removeClass('is-hidden');
   $(this).addClass('is-hidden');
});
$('.js-edit-address').on('click',function (){
    const formId = $(this).attr('data-form-id');
    $(`#EditAddress_${formId}`).removeClass('is-hidden');
});
$('.js-add-address-cancel').on('click',function (){
    $(this).closest('[data-form]').addClass('is-hidden');
    $('.js-add-address').removeClass('is-hidden');
});
$(document).on('change','.custom-contact-form-wrapper .globo-form-input select',function (){
    $(this).addClass("changed")
});
$('.js-option-info-btn').on('click',function (){
   const image = $(this).attr('data-image');
   const popup = $('.js-options-info-popup');
   const popupImage = $('.js-options-info-popup img');
    popupImage.attr('src',image);
    if(popupImage[0].complete == true){
        popup.addClass('open');
        $('body').addClass('custom-modal-open');
    }else{
        setTimeout(function (){
            popup.addClass('open');
            $('body').addClass('custom-modal-open');
        },500)
    }

});
$('.js-options-info-popup .options-info-popup-close').on('click',function (){
    $('.js-options-info-popup').removeClass('open');
    $('body').removeClass('custom-modal-open');
});
if(location.pathname.includes('products/set-creator')){
    location.pathname='/collections/set-creator'
}
$(document).on('click','[data-close-error]',function (){
    $(this).closest('[data-cart-errors-container]').removeClass('is-visible')
})
function quickViewOpen(){
    function selectTemplateResultQuickView(opt) {
        if (!opt.id) {
            return opt.text;
        }
        let swatch = $(opt.element).data("style");
        if(!swatch){
            let $opt = $(
                `<div class="select2-results__option-custom product-options-list-item quick-view-item">
               <span class="swatch" style="background-color: red"></span> <span class="label">${opt.text}</span>
        </div>`
            );
            return $opt;
        }else{
            let $opt = $(
                `<div class="select2-results__option-custom product-options-list-item quick-view-item">
               <span class="swatch" style="${swatch}"></span> <span class="label">${opt.text}</span>
        </div>`
            );
            return $opt;
        }
    }
    $('.js-option-dropdown-set').select2({
        minimumResultsForSearch: -1,
        templateResult: selectTemplateResultQuickView,
        templateSelection: selectTemplateSelection,
        placeholder: "Wähle die Farbe",
    });
    $('.js-set-products-list').slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: true,
        prevArrow: '<div class="slick-prev slick-arrow"></div>',
        nextArrow: '<div class="slick-next slick-arrow"></div>',
        responsive: [
            {
                breakpoint: 1020,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 475,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 374,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                }
            },
        ]
    });
    function getSwatchJson(){
        let jsonResult = {};
        $.ajax({
            url:theme.assets.swatches,
            dataType: 'json',
            async: false
        }).done(function(json) {
            jsonResult = json;
        }).fail(function(error) {
            console.log(error)
        });
        return jsonResult.colors;
    }

    let setProdutVariant = $('.js-set-product-options');
    let SwatchJson = getSwatchJson();
    setProdutVariant.each(function (index){
        const _this = $(this);
        const variantJson = JSON.parse($(this).find('[type="application/json"]').html());
        variantJson.forEach(function (item){
            const option = _this.find($(`option[data-title="${item.title}"]`));
            const colorOptions = SwatchJson.find(element => Object.keys(element).toString().toLowerCase()=== item.title.toLowerCase());
            if(colorOptions){
                const colorValue = Object.values(colorOptions).toString();
                const defaultPath = theme.assets.base || '/';
                if(colorValue.includes('#')){
                    option.attr('data-style', `background-color: ${colorValue};`)
                }else{
                    option.attr('data-style', `background-color: #cccccc;background-image: url(${defaultPath}${colorValue});`)
                }
            }
        })
        if(index == setProdutVariant.length-1){
            initSelect();
        }
    });
    $('.popup-quick-view .js-set-product-options select').on("change",function (){
        const selectedValue = parseInt($(this).find(":selected").val());
        const variantJson = JSON.parse($(this).closest('.js-set-product-options').find('[type="application/json"]').html());
        const selectedVariantJson = variantJson.find(variant => variant.id === selectedValue);
        let price = ``;
        if(selectedVariantJson.featured_image != null){
            $(this).closest('.set-products-list-item').find(".image-wrapper img").attr('src',selectedVariantJson.featured_image.src)
        }else{
            let defaultImage = $(this).closest('.set-products-list-item').find(".image-wrapper img").attr('data-default-image')
            $(this).closest('.set-products-list-item').find(".image-wrapper img").attr('src',defaultImage)
        }
        if(selectedVariantJson.compare_at_price != null){
            price = ` ${Shopify.formatMoney(selectedVariantJson.price)} <s>${Shopify.formatMoney(selectedVariantJson.compare_at_price)}</s>`
        }else{
            price = ` ${Shopify.formatMoney(selectedVariantJson.price)}`
        }
        $(this).closest('.set-products-list-item').find(".price").html(price);
    });
    $('.js-quick-view-add-set').on('click',function (e){
        e.preventDefault();
        const setVariants = $(this).closest('.product__form').find('.js-set-product-options select');
        let addToCart = true;
        let cartVariants = [];
        setVariants.each(function (){
            const value = $(this).find(":selected").val();
            const product = $(this).find(":selected").attr('data-product');
            // const variant = $(this).find(":selected").attr('data-title');
            const variant = $(this).find(":selected").attr('data-variant');
            var properties = {
                // 'Liquid_Lipstick': 'Set'
            };
            const propertiy_name = $(this).find(":selected").attr('data-property-name');
            const propertiy_value = $(this).find(":selected").attr('data-property-value');
            properties[propertiy_name] = propertiy_value;
            if(value != ""){
                var variantExsits = false;
                if(cartVariants.length > 0){
                    var variantExsits = false;
                    cartVariants.map(function (value,index){
                        if(value.id === variant){
                            cartVariants[index].quantity = cartVariants[index].quantity+1;
                            variantExsits = true;
                        }
                        if((index+1) == cartVariants.length){
                            if(!variantExsits){
                                cartVariants.push({
                                    id: variant,
                                    quantity: 1,
                                    price: 10,
                                    final_price: 10,
                                    properties
                                });
                            }
                        }
                    })
                }else{
                    cartVariants.push({
                        id: variant,
                        quantity: 1,
                        price: 10,
                        final_price: 10,
                        properties
                    });
                }
                let property = `<input type="hidden" class="js-set-properties" name="properties[${product}]" value="${variant}">`
                $(this).closest('form.product__form').prepend(property);
                $(this).closest('.js-set-product-options').find('.select2.select2-container').removeClass('error')
            }else {
                $(this).closest('.js-set-product-options').find('.select2.select2-container').addClass('error')
                addToCart = false;
            }
        })
        if(addToCart){
            
            let formData = {
                items: cartVariants
            };

            fetch('/cart/add.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    // Error function
                    errorMessage(response)
                    return;
                }
                setTimeout(function (){
                    updateCartDrawer(true);
                    let _this = $(this);
                    $(this).closest('.product__form').find('.quick-view-btn:not(.js-quick-view-add-set)').click();
                    $(this).addClass('is-loading');
                    $(this).closest('form.product__form').find('[data-cart-errors-container]').removeClass('is-visible')
                },500)
            })
            .catch((error) => {
                console.log(error);
            });
        }else{
            $('.js-set-properties').remove();
            $(this).closest('form.product__form').find('[data-cart-errors-container]').html(`<div class="errors">${theme.strings.set_error}<button type="button" class="product__errors__close" data-close-error>${theme.icons.closeSmall}</button></div>`)
            $(this).closest('form.product__form').find('[data-cart-errors-container]').addClass('is-visible')
        }
    })
}

// This function make sidebar visible while scrolling products
$(function() {
    var sidebar = $(".set-creator-cart");
    var offset = sidebar.offset();
    var topPadding = 110;
    var bottomOffset = $("footer").offset().top - $(window).height();
    
    $(window).scroll(function() {
        var scrollTop = $(window).scrollTop();
        if (window.innerWidth > 768 && scrollTop > offset.top) {
            if (scrollTop < bottomOffset) {
                sidebar.css({
                    position: 'fixed',
                    top: topPadding,
                });
            } else {
                sidebar.css({
                    position: 'absolute',
                    top: bottomOffset + topPadding
                });
            }
        } else {
            sidebar.css({
                position: 'static',
                top: 'auto'
            });
        };
    });
});

